import { Button } from "@design-system/Inputs/Button";
import { Editor, EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { useTranslation } from "react-i18next";
import "./i18n";

const MenuBar = ({
    editor,
    supplier,
    legacySupplier,
}: {
    editor: Editor | null;
    supplier?: boolean;
    legacySupplier?: boolean;
}) => {
    return (
        <div className="flex flex-wrap mb-2 space-x-1">
            <Button
                size="sm"
                variant="outlined"
                onClick={() => editor?.commands.insertContent("{{first_name}}")}
            >
                <div className="text-sm">{`{{first_name}}`}</div>
            </Button>
            <Button
                size="sm"
                variant="outlined"
                onClick={() => editor?.commands.insertContent("{{last_name}}")}
            >
                <div className="text-sm">{`{{last_name}}`}</div>
            </Button>

            {(supplier || legacySupplier) && (
                <Button
                    size="sm"
                    variant="outlined"
                    onClick={() =>
                        editor?.commands.insertContent("{{supplier}}")
                    }
                >
                    <div className="text-sm">{`{{supplier}}`}</div>
                </Button>
            )}
            <Button
                size="sm"
                variant="outlined"
                onClick={() =>
                    editor?.commands.insertContent("{{personal_link}}")
                }
            >
                <div className="text-sm">{`{{personal_link}}`}</div>
            </Button>
            {!supplier && (
                <Button
                    size="sm"
                    variant="outlined"
                    onClick={() =>
                        editor?.commands.insertContent("{{n_requests}}")
                    }
                >
                    <div className="text-sm">{`{{n_requests}}`}</div>
                </Button>
            )}
        </div>
    );
};

export const useReminderTextEditor = (
    type: "reporting" | "supplier" | "legacy_supplier",
) => {
    const { t } = useTranslation("ReminderTextEditor");

    const extensions = [StarterKit];
    const content = t(`${type}_default_message`);
    const editorProps = {
        attributes: {
            class: "prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl focus:outline-none p-4 border border-secondary rounded-lg",
        },
    };
    const editor = useEditor({
        extensions,
        content,
        editorProps,
    });
    return editor;
};
export const Tiptap = ({
    editor,
    supplier,
    legacySupplier,
}: {
    editor: Editor | null;
    supplier?: boolean;
    legacySupplier?: boolean;
}) => {
    return (
        <div className="space-y-3">
            <EditorContent editor={editor} />
            <MenuBar
                editor={editor}
                supplier={supplier}
                legacySupplier={legacySupplier}
            />
        </div>
    );
};
